import { Box, FormLabel, Heading, Stack } from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  closeCreateStudent,
  openShowStudentDataModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getPaymentExceptionRequest } from "../../../../modules/admin-modules/payment/Actions";
import {
  createStudentRequest,
  editStudentRequest,
} from "../../../../modules/admin-modules/students/Actions";
// import ShowPassword from '../models/show-password'

const AddStudent = ({ isAdd, data, setSelectedData, setAddedStudent }) => {
  const openStudent = useSelector((state) => state.model.isOpen1);
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.students.isLoading);
  const paymentException = useSelector(
    (state) => state.payments.paymentException
  );

  const dispatch = useDispatch();

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const paymentExceptionOptions = paymentException?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
      borderColor: errors?.chapter_id?.message ? "red" : "gray.200",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  useEffect(() => {
    if (openStudent) {
      dispatch(getAllGroupsRequest());
      dispatch(getPaymentExceptionRequest());
    }
  }, [openStudent]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الطالب" : "تعديل  الطالب"}
      </Heading>
    </Box>
  );
  const onSubmit = (values) => {
    const editGroup = values?.student_group_id
      ? values?.student_group_id
      : data?.group?.id;
    console.log(editGroup);
    const newDate = values?.reservation_date
      ? dayjs(values?.reservation_date).format("YYYY-MM-DD")
      : dayjs(data?.created_at).format("YYYY-MM-DD");

    const action = (data) => {
      dispatch(closeCreateStudent());
      setAddedStudent(data);
      dispatch(openShowStudentDataModel());
      reset();
    };
    let formData = new FormData();
    for (let key in { ...values }) {
      // Skip null/undefined values - don't append them to FormData
      if (values[key] !== null && values[key] !== undefined) {
        formData.append(key, values[key]);
      }
    }
    // Explicitly handle payment_exception_id - if it's null, append empty string to allow backend to set it to NULL
    if (values.payment_exception_id === null) {
      formData.append("payment_exception_id", "");
    }
    formData.append("reservation_date", newDate);
    // Convert start_time to 12-hour format with AM/PM
    const startTime24 = values?.reservation_date.split("T")[1];
    let startTime12 = "";
    if (startTime24) {
      const [hourStr, minute, second] = startTime24.split(":");
      let hour = parseInt(hourStr, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12;
      startTime12 = `${hour}:${minute} ${ampm}`;
    }
    formData.append("start_time", startTime12);
    formData.append("student_group_id", `${editGroup}`);

    if (isAdd) dispatch(createStudentRequest(formData, action));
    else {
      formData.append("_method", "PUT");

      dispatch(
        editStudentRequest({
          id: data?.id,
          formData: formData,
          action: () => {
            dispatch(closeCreateStudent());
          },
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateStudent());
    setSelectedData && setSelectedData({});
    reset();
  };
  return (
    <>
      <MainModel
        header={header}
        closeFunc={closeFunc}
        openVar={openStudent}
        buttonTitle={isAdd ? " إضافة الطالب" : "تعديل  الطالب"}
        isLoading={isLoading}
        buttonFunc={handleSubmit(onSubmit)}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={5} dir="rtl" w="100%">
            <Box w="100%" display="flex" flexDirection="row" gap={2}>
              <Box w="50%">
              <MainInput
                defaultValues={data?.name}
                label="اسم الطالب *"
                error={errors?.name?.message}
                placeholder="ادخل اسم الطالب"
                register={register}
                name="name"
              />
              </Box>
              <Box w="50%">
              <MainInput
                defaultValues={data?.user_name}
                label="كود الحضور"
                error={errors?.user_name?.message}
                placeholder="ادخل كود الحضور"
                register={register}
                name="user_name"
                required={false}
              />
              </Box>
            </Box>
            <Box w="55%">
              <MainInput
                defaultValues={data?.phone}
                label="رقم الموبايل *"
                error={errors?.phone?.message}
                placeholder="اكتب رقم الموبايل"
                register={register}
                name="phone"
              />
            </Box>
            <Box w="55%">
              <MainInput
                defaultValues={data?.parent_phone}
                label="رقم موبايل ولي الأمر *"
                error={errors?.parent_phone?.message}
                placeholder="اكتب رقم موبايل ولي الأمر"
                register={register}
                name="parent_phone"
              />
            </Box>
            <Box w="55%">
              <FormLabel>المجموعة *</FormLabel>
              <Select
                defaultValue={{
                  label: data?.group?.name,
                  value: data?.group?.id,
                }}
                options={groupsOptions}
                onChange={(data) => {
                  setValue("student_group_id", data.value);
                }}
                styles={colourStyles}
                placeholder="الفصول"
              />
            </Box>
            <Box w="55%">
              <MainInput
                defaultValues={data?.assistant_phone}
                label="رقم موبايل المساعد"
                error={errors?.assistant_phone?.message}
                placeholder="اكتب رقم موبايل المساعد"
                register={register}
                name="assistant_phone"
                required={false}
              />
            </Box>
            <Box w="55%">
              <MainInput
                defaultValues={data?.school}
                label=" المدرسة "
                error={errors?.school?.message}
                placeholder="اكتب المدرسة"
                register={register}
                name="school"
                required={false}
              />
            </Box>
            <Box w="55%">
              <MainInput
                type="datetime-local"
                label="موعد بداية الحصة"
                error={errors?.reservation_date?.message}
                placeholder="اكتب موعد بداية الحصة"
                register={register}
                defaultValues={dayjs(data?.reservation_date).format(
                  "YYYY-MM-DDThh:mm"
                )}
                name="reservation_date"
              />
            </Box>

            <Box w="55%">
              <FormLabel>استثناءات الدفع : </FormLabel>
              <Select
                defaultValue={{
                  label: data?.payment_exception?.name,
                  value: data?.payment_exception?.id,
                }}
                options={paymentExceptionOptions}
                onChange={(data) => {
                  setValue("payment_exception_id", data ? data.value : null);
                }}
                styles={colourStyles}
                placeholder="طرق الدفع"
                isClearable
              />
            </Box>
          </Stack>
        </form>
      </MainModel>

      {/* <ShowPassword data={studentData} /> */}
    </>
  );
};

export default AddStudent;
